module.exports = __webpack_public_path__ + "img/00015.5c19fbaa.webp";